import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { useSettings } from "../lib/SettingsContext";
import { normalizePhone } from "../lib/whatsapp";
import { MessageCircle, X } from "lucide-react";

/**
 * Floating fixed WhatsApp button — bottom-right corner on all public pages.
 * Hidden on admin routes and when there is no company_whatsapp configured.
 * Uses a small "pulse" ring to attract attention.
 */
export default function WhatsAppBubble() {
  const { settings } = useSettings();
  const location = useLocation();
  const [dismissed, setDismissed] = useState(false);

  // Never render on admin routes
  if (location.pathname.startsWith("/admin")) return null;

  const phone = normalizePhone(settings?.company_whatsapp);
  if (!phone) return null;

  const brand = settings?.brand_name || "Printec";
  const text = encodeURIComponent(`Hola ${brand}, quisiera más información.`);
  const href = `https://wa.me/${phone}?text=${text}`;

  return (
    <div className="fixed bottom-5 right-5 z-50 flex items-end gap-2" data-testid="wa-bubble">
      {!dismissed && (
        <div className="hidden sm:flex items-center gap-2 bg-white shadow-lg border border-neutral-200 pl-4 pr-2 py-2 max-w-[260px]">
          <div className="text-xs">
            <div className="font-medium text-neutral-900">¿Dudas o cotización?</div>
            <div className="text-neutral-500 text-[11px]">Responde un asesor por WhatsApp.</div>
          </div>
          <button
            type="button"
            onClick={() => setDismissed(true)}
            className="p-1 hover:bg-neutral-100 text-neutral-400"
            aria-label="Cerrar sugerencia"
            data-testid="wa-bubble-dismiss"
          >
            <X className="w-3 h-3" />
          </button>
        </div>
      )}
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className="relative w-14 h-14 rounded-full bg-emerald-600 hover:bg-emerald-700 text-white shadow-2xl flex items-center justify-center transition-colors"
        aria-label="Chatear por WhatsApp"
        data-testid="wa-bubble-btn"
      >
        <span className="absolute inset-0 rounded-full bg-emerald-500 opacity-60 animate-ping" />
        <MessageCircle className="w-7 h-7 relative" />
      </a>
    </div>
  );
}
